export default "__VITE_ASSET__1ae3d266__"